import { validationRules } from '../validationRules';
import { ValidateResponse } from '../Validator';
import { TimeEntry, TimeUser, TimeUserFeatures } from '../../api/generated/data-contracts';
import { format } from '../../helpers/date';

interface OnlyAllowWithinEmploymentValdationProps {
    user: TimeUser;
    timeEntries: TimeEntry[];
    // uiContext: IUiContext;
    config: TimeUserFeatures;
}

export const OnlyAllowWithinEmployment = (props: OnlyAllowWithinEmploymentValdationProps): ValidateResponse => {
    //TODO: Find better way
    const minDate = new Date('1900,1,1');
    const user = (props.user as any).user;

    const isStarted = true;
    let startdatestring = 'N/A';
    let enddatestring = 'N/A';
    console.debug('OnlyAllowWithinEmployment', user.start, user.end);
    let userstartdate = new Date(1900, 0, 1, 0, 0, 0);
    if (user.start != undefined && user.start != null && new Date(user.start).getFullYear() > 1900) {
        userstartdate = user.start;
        startdatestring = format(new Date(userstartdate), props.config.dateFormat);
    }
    let userenddate = new Date(2049, 12, 1, 0, 0, 0);

    if (user.end != undefined && user.end != null && new Date(user.end).getFullYear() > 1900 && new Date(user.end).getFullYear() < 2049) {
        userenddate = user.end;
        enddatestring = format(new Date(userenddate), props.config.dateFormat);
    }

    let valid = true;
    const timeentreies = props.timeEntries;
    const timeentriesoutsideemployment = timeentreies.find(
        te =>
            te.hours != 0 && (new Date(te.date).getTime() < new Date(userstartdate).getTime() || new Date(te.date).getTime() > new Date(userenddate).getTime()),
    );
    if (timeentriesoutsideemployment != undefined && timeentriesoutsideemployment != null) {
        valid = false;
    }

    const response: ValidateResponse = {
        reason: valid ? null : `It is only allowed to report hours within your first and last working day (${startdatestring} - ${enddatestring}) `,
        valid: valid,
        // name: validationRules.OnlyAllowWithinEmployment,
        name: validationRules.onlyAllowWithinEmployment,
        rejected: !valid,
    };

    return response;
};
